import { tasksConstants } from "../../../constants/tasks";
import { CheckAttributTaskForSearch } from "../../../utils/filters";

const initialState = {
  loading: true,
  projects: [],
  list: [],
  task: null,
  tags: [],
  filtred: [],
  filter: null,
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case tasksConstants.GET_PROJECTS:
      return {
        ...state,
        loading: false,
        projects: payload,
      };
    case tasksConstants.GET_TASKS:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case tasksConstants.FILTER_TASK:
      return {
        ...state,
        loading: false,
        filtred: payload.data,
        filter: payload.filter,
      };
    case tasksConstants.SEARCH_TASKS:
      let data = state.list.filter((task) =>
        CheckAttributTaskForSearch(payload.term, task)
      );
      return {
        ...state,
        loading: false,
        filtred: data,
        filter: payload.term,
      };

    case tasksConstants.SHOW_ALL:
      return {
        ...state,
        loading: false,
        filtred: [],
        filter: null,
      };
    case tasksConstants.GET_TAGS:
      return {
        ...state,
        loading: false,
        tags: payload,
      };
    case tasksConstants.TASK_DETAILS:
      return {
        ...state,
        loading: false,
        task: payload,
      };
    default:
      return state;
  }
}
